import store from '@/store'
import AppWarn from './errors/app-warns'
import http from './webhook/httpconfig'
import { getCookie } from './cookie'
import { cookieConstant } from './constants'
import { cancelHTTPRequests } from '@/services/utils'
import { generateHeaders } from './webhook/webhook'

async function oauthRequest(endpoint, additionalParams = {}) {
  try {
    const { getBotRefId } = store?.getters || {}
    const payload = {
      botRefId: getBotRefId,
      conversationId: getCookie(cookieConstant.SESSION.CONVERSATION_ID),
      ...additionalParams
    }
    const result = await http.request({
      method: 'get',
      url: `/api/oauth/${endpoint}`,
      params: payload,
      headers: {
        'Cache-Control': 'no-cache',
        ...generateHeaders()
      },
      cancelToken: cancelHTTPRequests()
    })
    return result
  } catch (error) {
    throw new AppWarn({name: 'oauth request service', message:`Error while request for oauth ${error.message}`})
  }
}

function oauthLogin(authorization_code, access_token) {
  return oauthRequest('login', { code: authorization_code, token: access_token })
}

function oauthLogout() {
  return oauthRequest('logout')
}

export { oauthLogin, oauthLogout }
